export default "__VITE_ASSET__34dc82b5__"